import styled from 'styled-components';
import { AspectRatio } from '../AspectRatio/index.js';

const FadeInPicture = styled.picture`
  & > img {
    opacity: ${({
  isInvisible,
  noAnimation
}) => isInvisible && !noAnimation ? '0' : '1'};
    ${({
  noAnimation
}) => noAnimation ? '' : 'transition: opacity 350ms ease-in-out;'}
    display: block;
  }
`;
const StyledAspectRatio = styled(AspectRatio)`
  flex-shrink: 0;
  img {
    ${props => props.ratio && (props.height || props.width) && props.objectFit ? `object-fit: ${props.objectFit};` : ''}
    ${props => (props.width || props.ratio && props.height) && 'width: 100%;'}
    ${props => (props.height || props.ratio && props.width) && 'height: 100%;'}
  }
`;

export { FadeInPicture, StyledAspectRatio };
